export default __webpack_public_path__ + "static/media/cakebanner4.34b77e47.jpg";